var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[(!_vm.ready)?_c('div',{staticClass:"text-center"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}}),_c('div',{staticStyle:{"margin-top":"20px"}},[_vm._v("Authenticating")])],1):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }